import React from 'react';
const SvgTextfile = React.forwardRef((rest, ref) => {
  const props = { ...rest, ref };
  return (
    <svg viewBox="0 0 32 32" width="1em" height="1em" {...props}>
      <path fill="#769CC2" d="M22 1l7 7h-7V1z" />
      <path fill="#5C7896" d="M3 1v30h26V8h-7V1H3z" />
      <path opacity={0.3} fill="#1B3F63" d="M29 15l-7-7h7v7z" />
      <g fill="#FFF">
        <path d="M8 10h16v2H8zM8 14h16v2H8zM8 18h16v2H8zM8 22h13v2H8z" />
      </g>
    </svg>
  );
});
export default SvgTextfile;
SvgTextfile.iconName = 'textfile';
SvgTextfile.displayName = 'SvgTextfile';
